import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Region} from './region.model';
import { EMPTY_OPTION, MultiSelectOption } from '../../shared/utils/utils.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class RegionService {

    private regionsUrl = 'api/regions';

    public regions: Region[] = [];

    constructor(private http: Http) { }

    getRegions(req?: any, force = false): Observable<Region[]> {
        if (!force && this.regions.length) {
            return of(this.regions);
        }
        let options = this.createRequestOption(req);
        return this.http.get(this.regionsUrl, options)
            .map((res: Response) => {
                this.regions = res.json() as Region[];
                return this.regions;
            });
    };

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('campaign', req.campaign);
            options.search = params;
        }
        return options;
    }

    getRegionOptions(): MultiSelectOption[] {
        return [EMPTY_OPTION].concat(...this.regions.map(r => { return { 'value': r.academicRegionLabel, 'label': r.academicRegionLabel }; }).sort((a, b) => a.label.localeCompare(b.label)));
    }
    getAcademyOptions(academicRegionLabel?: string): MultiSelectOption[] {
        if (academicRegionLabel) {
            return [EMPTY_OPTION].concat(...this.regions.find(r => r.academicRegionLabel === academicRegionLabel).academies.map(a => { return { 'value': a.academyCode, 'label': a.academyLabel }; }).sort((a, b) => a.label.localeCompare(b.label)));
        }
        return [EMPTY_OPTION].concat(...this.regions.map(r => r.academies.map(a => { return { 'value': a.academyCode, 'label': a.academyLabel }; })).reduce((acc, val) => acc.concat(val), []).sort((a, b) => a.label.localeCompare(b.label)));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/region.service.ts